/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface FollowUpViewModel {
  visitId?: string;
  accountNumber?: number;
  fullName?: string | null;
  visit?: number;
  balance?: number;
  serviceDate?: string;
  insuranceCarrierNumber?: string | null;
  insuranceCarrierName?: string | null;
  assignDate?: string | null;
  followUpDate?: string;
  note?: string | null;
  patientId?: string;
  providerId?: string;
  assignedUserId?: string;
  userFirstName?: string | null;
  userLastName?: string | null;
  assignDateDisplay?: string | null;
  userFullName?: string | null;
  insuranceId?: string | null;
  readonly queue?: string | null;
  readonly iconType?: string | null;
  readonly resultDescription?: string | null;
  readonly additionalDetails?: Array<string> | null;
}
